module.exports = __webpack_public_path__ + "img/table-order-phone.40bb7db2.svg";